module.exports = __webpack_public_path__ + "img/DS6205X7.eed76a35.jpg";